import { render, staticRenderFns } from "./StopMentorshipModal.vue?vue&type=template&id=29e28286&"
import script from "./StopMentorshipModal.vue?vue&type=script&lang=js&"
export * from "./StopMentorshipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports